export default "__VITE_PUBLIC_ASSET__44a89d18__"